import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A carriable good: a small bundle of three logs, ported 1:1 from the game's
// `goods` (the `wood` item's `held()` bundle). Authored about its own origin at
// "held" scale, so it drops straight into a carry socket on the player or worker
// avatar via `bakeSockets`.
const BARK = "#6b4a2a";
const LOG_END = "#b88c54";

// One log lying along x (cradled crosswise), with pale sawn ends. `len` is its
// length, `r` its radius.
function logUnit(cx: number, cy: number, cz: number, len: number, r: number): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(r, r, len, 7), color: BARK, position: [cx, cy, cz], rotation: [0, 0, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(r * 0.92, r * 0.92, 0.01, 7), color: LOG_END, position: [cx + len / 2, cy, cz], rotation: [0, 0, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(r * 0.92, r * 0.92, 0.01, 7), color: LOG_END, position: [cx - len / 2, cy, cz], rotation: [0, 0, Math.PI / 2] },
  ];
}

export const woodBundle = defineModel({
  id: "wood-bundle",
  batchId: "characters",
  name: "Wood bundle",
  tags: ["good", "cargo", "wood"],
  fits: ["carry"],
  summary: "A small bundle of logs — a carriable good for an avatar's carry socket.",
  description:
    "Three stacked logs at held scale, ported from age-of-mcp's goods (`wood`). " +
    "Mount it in a player's or worker's `carry` socket to show the figure " +
    "hauling wood.",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: (): Part[] => [
    ...logUnit(0, 0.03, 0.0, 0.17, 0.03),
    ...logUnit(0, 0.085, -0.01, 0.16, 0.027),
    ...logUnit(0, 0.06, 0.04, 0.15, 0.026),
  ],
  animations: [],
});
